/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  List, Container, Checkbox, Segment, Form,
  Popup, Header, Divider, Button, Dimmer,
  Loader, Icon, Input, Grid
} from "semantic-ui-react";
import Constants from "../utilities/Constants";
import Strings from "../utilities/StringSelector";
import Utils from "../utilities/Utils";

const MAX_PING_LIMIT = 10000;
const UtilsInstance = new Utils();

export class TsExpertConfig extends Component {
  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      isSendingConfigDimmerActive: false,

      isAlarmProblemChecked: false,
      isFaultProblemChecked: false,
      isDuplicateIpProblemChecked: false,
      isDuplicateNameProblemChecked: false,
      isAvgPingExceededLimitProblemChecked: false,
      isErrorIncrementProblemChecked: false,
      isPortNotInRecommendedDuplexProblemChecked: false,
      isTrafficExceededProblemChecked: false,
      isInactivePortProblemChecked: false,
      isHardwareFirmwareProblemChecked: false,
      isConfigProblemChecked: false,
      isDuplexMismatchProblemChecked: false,
      isLineDelayExceededLimitChecked: false,
      isIntermittentFailureChecked: false,
      isLostIpProblemChecked: false,

      isAlterPingDimmerActive: false,
      pingLimit: ""
    };
  }

  retrieveData = () => {
    fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertConfig", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({
        isAlarmProblemChecked: data.isAlarmProblemChecked,
        isFaultProblemChecked: data.isFaultProblemChecked,
        isDuplicateIpProblemChecked: data.isDuplicateIpProblemChecked,
        isDuplicateNameProblemChecked: data.isDuplicateNameProblemChecked,
        isAvgPingExceededLimitProblemChecked: data.isAvgPingExceededLimitProblemChecked,
        isErrorIncrementProblemChecked: data.isErrorIncrementProblemChecked,
        isPortNotInRecommendedDuplexProblemChecked: data.isPortNotInRecommendedDuplexProblemChecked,
        isTrafficExceededProblemChecked: data.isTrafficExceededProblemChecked,
        isInactivePortProblemChecked: data.isInactivePortProblemChecked,
        isHardwareFirmwareProblemChecked: data.isHardwareFirmwareProblemChecked,
        isConfigProblemChecked: data.isConfigProblemChecked,
        isDuplexMismatchProblemChecked: data.isDuplexMismatchProblemChecked,
        isLineDelayExceededLimitChecked: data.isLineDelayExceededLimitChecked,
        isIntermittentFailureChecked: data.isIntermittentFailureChecked,
        isLostIpProblemChecked: data.isLostIpProblemChecked,
      }));

    fetch(Constants.REQUEST_IP_ADDRESS + "pingLimitConfig", { mode: "cors" })
      .then(res => res.json())
      .then(data => this.setState({ pingLimit: data.pingLimit }));
  }

  // ------ Toggle Checkboxes ---------
  toggleIsAlarmProblemCheckbox = () => {
    this.setState({ isAlarmProblemChecked: !this.state.isAlarmProblemChecked });
  }

  toggleIsFaultProblemCheckbox = () => {
    this.setState({ isFaultProblemChecked: !this.state.isFaultProblemChecked });
  }

  toggleIsDuplicateIpProblemCheckbox = () => {
    this.setState({ isDuplicateIpProblemChecked: !this.state.isDuplicateIpProblemChecked });
  }

  toggleIsDuplicateNameProblemCheckbox = () => {
    this.setState({ isDuplicateNameProblemChecked: !this.state.isDuplicateNameProblemChecked });
  }

  toggleIsAvgPingExceededLimitProblemCheckbox = () => {
    this.setState({ isAvgPingExceededLimitProblemChecked: !this.state.isAvgPingExceededLimitProblemChecked });
  }

  toggleIsErrorIncrementProblemCheckbox = () => {
    this.setState({ isErrorIncrementProblemChecked: !this.state.isErrorIncrementProblemChecked });
  }

  toggleIsPortNotInRecommendedDuplexProblemCheckbox = () => {
    this.setState({ isPortNotInRecommendedDuplexProblemChecked: !this.state.isPortNotInRecommendedDuplexProblemChecked });
  }

  toggleIsTrafficExceededProblemCheckbox = () => {
    this.setState({ isTrafficExceededProblemChecked: !this.state.isTrafficExceededProblemChecked });
  }

  toggleIsInactivePortProblemCheckbox = () => {
    this.setState({ isInactivePortProblemChecked: !this.state.isInactivePortProblemChecked });
  }

  toggleIsHardwareFirmwareProblemCheckbox = () => {
    this.setState({ isHardwareFirmwareProblemChecked: !this.state.isHardwareFirmwareProblemChecked });
  }

  toggleIsConfigProblemCheckbox = () => {
    this.setState({ isConfigProblemChecked: !this.state.isConfigProblemChecked });
  }

  toggleIsDuplexMismatchProblemCheckbox = () => {
    this.setState({ isDuplexMismatchProblemChecked: !this.state.isDuplexMismatchProblemChecked });
  }

  toggleIsLineDelayExceededLimitProblemCheckbox = () => {
    this.setState({ isLineDelayExceededLimitChecked: !this.state.isLineDelayExceededLimitChecked });
  }

  toggleIsIntermittentFaultsProblemCheckbox = () => {
    this.setState({ isIntermittentFailureChecked: !this.state.isIntermittentFailureChecked });
  }

  toggleIsLostIpProblemCheckbox = () => {
    this.setState({ isLostIpProblemChecked: !this.state.isLostIpProblemChecked });
  }

  // Save the TS Expert Configuration
  saveTsExpertConfiguration = () => {
    this.showSendingConfigDimmer();

    let data = {
      isAlarmProblemChecked: this.state.isAlarmProblemChecked,
      isFaultProblemChecked: this.state.isFaultProblemChecked,
      isDuplicateIpProblemChecked: this.state.isDuplicateIpProblemChecked,
      isDuplicateNameProblemChecked: this.state.isDuplicateNameProblemChecked,
      isAvgPingExceededLimitProblemChecked: this.state.isAvgPingExceededLimitProblemChecked,
      isErrorIncrementProblemChecked: this.state.isErrorIncrementProblemChecked,
      isPortNotInRecommendedDuplexProblemChecked: this.state.isPortNotInRecommendedDuplexProblemChecked,
      isTrafficExceededProblemChecked: this.state.isTrafficExceededProblemChecked,
      isInactivePortProblemChecked: this.state.isInactivePortProblemChecked,
      isHardwareFirmwareProblemChecked: this.state.isHardwareFirmwareProblemChecked,
      isConfigProblemChecked: this.state.isConfigProblemChecked,
      isDuplexMismatchProblemChecked: this.state.isDuplexMismatchProblemChecked,
      isLineDelayExceededLimitChecked: this.state.isLineDelayExceededLimitChecked,
      isIntermittentFailureChecked: this.state.isIntermittentFailureChecked,
      isLostIpProblemChecked: this.state.isLostIpProblemChecked,
    };

    fetch(Constants.REQUEST_IP_ADDRESS + "tsExpertConfig_POST", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: JSON.stringify(data)
    })
      .then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.TS_EXPERT_CONFIG_SAVED_SUCCESSFULLY);
      })
      .catch((error) => {
        alert(Strings.TS_EXPERT_CONFIG_SAVE_ERROR + "\n" + Strings.REASON_DP + error);
      })
      .finally(this.hideSendingConfigDimmer);
  }

  showSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: true });

  hideSendingConfigDimmer = () => this.setState({ isSendingConfigDimmerActive: false });

  // Save Ping Limit
  alterPingLimit = () => {
    let typedNumber = Number(this.state.pingLimit);

    // Only let the user save ping values between the min and max packet values
    if (typedNumber >= 0 && typedNumber <= MAX_PING_LIMIT) {

      this.showAlterPingDimmer();

      fetch(Constants.REQUEST_IP_ADDRESS + "alterPingLimit_POST", {
        method: "POST",
        headers: {
          "Content-Type": "application/json;charset=UTF-8"
        },
        body: JSON.stringify({ pingLimit: typedNumber })
      })
        .then(UtilsInstance.checkStatus)
        .then(() => {
          alert(Strings.ALTER_PING_LIMIT_SUCCESS);
          this.retrieveData();
        })
        .catch((error) => {
          alert(Strings.ALTER_PING_LIMIT_ERROR + "\n" + Strings.REASON_DP + error.message);
        })
        .finally(this.hideAlterPingDimmer);

    }
    else {
      alert(Strings.PING_LIMIT_OUT_OF_BOUNDS + "\n" + Strings.CURRENT_VALUE_DP + this.state.pingLimit + " ms");
    }
  }

  showAlterPingDimmer = () => this.setState({ isAlterPingDimmerActive: true })

  hideAlterPingDimmer = () => this.setState({ isAlterPingDimmerActive: false })

  handlePingLimitChange = (e, { value }) => {
    this.setState({ pingLimit: value });
  }

  // Verifies if the user has the credentials to be logged in
  // If he does he is re-directed to the configuration page
  // If he doesn't he is re-directed to the login page
  isUserLoggedIn = () => {
    if (sessionStorage.auth !== Constants.AUTH_STR) {
      this.props.history.push({ pathname: "/login" });
    }
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    this.isUserLoggedIn();
    this.retrieveData();
  }

  render() {
    return (
      <Container className="ts-config-subpage ts-config-expert-page">
        <Grid columns={2} doubling>
          <Grid.Column width={10}>
            <Segment>
              <Header as='h2' textAlign="center" color="teal">
                {Strings.TS_EXPERT_CONFIGURATION}
              </Header>
              <Divider clearing />

              <Segment id="problems-list" style={listSegmentStyle} basic>

                <List divided verticalAlign='middle'>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_DIAGNOSTIC_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_DIAGNOSTIC_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsAlarmProblemCheckbox}
                            checked={this.state.isAlarmProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_FAULT_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_FAULT_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsFaultProblemCheckbox}
                            checked={this.state.isFaultProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.DUPLICATE_IP_STRING}</List.Header>
                          {Strings.CONFIG_DUPLICATE_IP_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsDuplicateIpProblemCheckbox}
                            checked={this.state.isDuplicateIpProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_DUPLICATE_NAME_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_DUPLICATE_NAME_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsDuplicateNameProblemCheckbox}
                            checked={this.state.isDuplicateNameProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_EXCEEDED_PING_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_EXCEEDED_PING_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsAvgPingExceededLimitProblemCheckbox}
                            checked={this.state.isAvgPingExceededLimitProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                  <List.Item>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.CONFIG_ERROR_INCREMENT_LIST_HEADER}</List.Header>
                        {Strings.CONFIG_ERROR_INCREMENT_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleIsErrorIncrementProblemCheckbox}
                          checked={this.state.isErrorIncrementProblemChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Item>

                  <List.Item>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.CONFIG_DUPLEX_LIST_HEADER}</List.Header>
                        {Strings.CONFIG_DUPLEX_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleIsPortNotInRecommendedDuplexProblemCheckbox}
                          checked={this.state.isPortNotInRecommendedDuplexProblemChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Item>

                  <List.Item>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.CONFIG_TRAFFIC_EXCEEDED_LIST_HEADER}</List.Header>
                        {Strings.CONFIG_TRAFFIC_EXCEEDED_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleIsTrafficExceededProblemCheckbox}
                          checked={this.state.isTrafficExceededProblemChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Item>

                  <List.Item>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.CONFIG_INACTIVE_PORT_LIST_HEADER}</List.Header>
                        {Strings.CONFIG_INACTIVE_PORT_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleIsInactivePortProblemCheckbox}
                          checked={this.state.isInactivePortProblemChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Item>

                  <List.Item>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.HW_FW_PORT_LIST_HEADER}</List.Header>
                        {Strings.HW_FW_PORT_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleIsHardwareFirmwareProblemCheckbox}
                          checked={this.state.isHardwareFirmwareProblemChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Item>

                  <List.Item>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.CONFIG_ERROR_CONFIG_LIST_HEADER}</List.Header>
                        {Strings.CONFIG_ERROR_CONFIG_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleIsConfigProblemCheckbox}
                          checked={this.state.isConfigProblemChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Item>

                  <List.Item>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.DUPLEX_MISMATCH_CONFIG_LIST_HEADER}</List.Header>
                        {Strings.DUPLEX_MISMATCH_CONFIG_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleIsDuplexMismatchProblemCheckbox}
                          checked={this.state.isDuplexMismatchProblemChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Item>

                  <List.Item>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.DELAY_EXCEEDED_CONFIG_LIST_HEADER}</List.Header>
                        {Strings.DELAY_EXCEEDED_CONFIG_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleIsLineDelayExceededLimitProblemCheckbox}
                          checked={this.state.isLineDelayExceededLimitChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Item>

                  <List.Item>
                    <Grid columns={2}>
                      <Grid.Column width={14}>
                        <List.Header>{Strings.CONFIG_INTERMITTENT_FAILURE_LIST_HEADER}</List.Header>
                        {Strings.CONFIG_INTERMITTENT_FAILURE_LIST_CONTENT}
                      </Grid.Column>
                      <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                        <Checkbox
                          toggle
                          onChange={this.toggleIsIntermittentFaultsProblemCheckbox}
                          checked={this.state.isIntermittentFailureChecked} />
                      </Grid.Column>
                    </Grid>
                  </List.Item>

                  <List.Item>
                    <List.Content>
                      <Grid columns={2}>
                        <Grid.Column width={14}>
                          <List.Header>{Strings.CONFIG_LOST_IP_LIST_HEADER}</List.Header>
                          {Strings.CONFIG_LOST_IP_LIST_CONTENT}
                        </Grid.Column>
                        <Grid.Column width={2} verticalAlign="middle" textAlign="right">
                          <Checkbox
                            toggle
                            onChange={this.toggleIsLostIpProblemCheckbox}
                            checked={this.state.isLostIpProblemChecked} />
                        </Grid.Column>
                      </Grid>
                    </List.Content>
                  </List.Item>

                </List>

              </Segment>

              <Button
                fluid
                color="teal"
                content={Strings.SAVE}
                onClick={this.saveTsExpertConfiguration} />

              <Dimmer active={this.state.isSendingConfigDimmerActive} >
                <Loader size="big">{Strings.SENDING_TS_EXPERT_CONFIG_WAITING}</Loader>
              </Dimmer>

            </Segment>

          </Grid.Column>

          <Grid.Column width={6}>
            <Segment>
              <Divider horizontal>
                {Strings.PING_LIMIT}
                <Popup position='bottom center' hoverable pinned wide
                  trigger={
                    <Icon name="question circle" color="teal" style={questionIconStyle} />
                  }>
                  <Popup.Content>
                    <p> {Strings.PING_LIMIT_POPUP_1} </p>
                    <p> {Strings.PING_LIMIT_POPUP_2} </p>
                    <p> <b>OBS 1:</b> {Strings.PING_LIMIT_POPUP_3} </p>
                    <p> <b>OBS 2:</b>  {Strings.PING_LIMIT_POPUP_4} </p>
                    <p> <b>OBS 3:</b>  {Strings.PING_LIMIT_POPUP_5} </p>
                  </Popup.Content>
                </Popup>
              </Divider>

              <Form style={formStyle} onSubmit={this.alterPingLimit}>
                <Form.Field inline>
                  <Input
                    className="ts-ping-limit-input"
                    type="number"
                    placeholder='200'
                    label={{ basic: true, content: "ms" }}
                    labelPosition='right'
                    value={this.state.pingLimit}
                    onChange={this.handlePingLimitChange} />
                </Form.Field>
                <Button color="teal" type="submit" >{Strings.SETUP}</Button>
              </Form>

              <Dimmer active={this.state.isAlterPingDimmerActive} >
                <Loader>{Strings.WAITING}</Loader>
              </Dimmer>
            </Segment>
          </Grid.Column>
        </Grid>


      </Container>
    );
  }
}

const listSegmentStyle = {
  overflowY: "scroll",
  height: "56vh"
};

const formStyle = {
  marginTop: "24px",
  textAlign: "center",
  width: "100%"
};

const questionIconStyle = {
  marginLeft: "4px"
};

export default TsExpertConfig;
